import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  Calendar,
  CalendarService,
  CalendarType,
  CommonDataService,
  CommonTransformationService,
  GrowlType,
  OverTimeConfigParams,
  PrimeNgConfig,
  RegExp3DigitInteger2DigitFraction,
  RouteLink,
  TableColumn,
  TimesheetOvertimeConfig,
  UserSearch,
  Validation
} from "@app/shared";
import {plainToClass} from "class-transformer";
import {SelectItem} from "primeng/api";
import {forkJoin} from "rxjs/internal/observable/forkJoin";
import {TimesheetAdminDataService} from "@app/finance/time/timesheet-admin/timesheet-admin-data.service";
import {GrowlService} from "@app/core";

@Component({
  selector: 'app-alternate-work-week',
  templateUrl: './alternate-work-week.component.html',
  styleUrls: ['./alternate-work-week.component.css'],
  providers: [TimesheetAdminDataService]
})
export class AlternateWorkWeekComponent implements OnInit, AfterViewInit {

  PrimeNgConfig: typeof PrimeNgConfig = PrimeNgConfig;
  RouteLink: typeof RouteLink = RouteLink;
  Validation: typeof Validation = Validation;
  RegExp3DigitInteger2DigitFraction = RegExp3DigitInteger2DigitFraction;

  users: UserSearch[];
  userDropDown: SelectItem[];
  yearDropDown: SelectItem[];

  tableColumns: TableColumn[]

  displayGenerateOvertimeDialog: boolean = false;
  @Input() disableUserSwitch: boolean = false;
  @Input() allowEdit: boolean = true;
  @Input() selectedYear: string;
  @Input() selectedUser: number;
  overtimeConfigs: TimesheetOvertimeConfig[];


  timesheetPeriodsForYear: Calendar [] = [];
  timesheetPeriodOptions: SelectItem[];

  params: OverTimeConfigParams = new OverTimeConfigParams();

  @ViewChild('yearTemplate') yearTemplate: TemplateRef<any>;

  constructor(private commonDataService: CommonDataService, private transformService: CommonTransformationService,
              private calendarService: CalendarService, private growlService: GrowlService,
              private timesheetAdminDataService: TimesheetAdminDataService) { }

  ngOnInit(): void {

    this.getDropDowns();
    this.getOverTimeConfig();
  }

  ngAfterViewInit(): void {
    this.initTables();
  }




  initTables() {
    this.tableColumns = [
      {field: 'periodStart', header: 'Period Start'},
      {field: 'periodDisplay', header: 'Period'},
      {field: 'workingHoursPerWeek', header: 'Working Hours Per Week'}
    ];
  }

  refreshOverTimeConfig() {
    this.getOverTimeConfig();
  }

  onClickShowConfiguration() {

    this.getPeriodsForYear();
    this.params = new OverTimeConfigParams();
    this.params.userId = this.selectedUser;
    this.params.year = this.selectedYear;

    this.displayGenerateOvertimeDialog = true;

  }

  getPeriodsForYear() {
    this.calendarService.getCalendarsForYearAsDropdown(CalendarType.Timesheet, this.selectedYear).subscribe(res => {
      this.timesheetPeriodOptions = res;
    });
  }

  onClickCancelGenerateConfiguration() {
    this.displayGenerateOvertimeDialog = false;
  }

  onClickGenerateConfiguration() {
    this.timesheetAdminDataService.generateOverTimeConfig(this.params).subscribe(res => {
      this.overtimeConfigs = plainToClass(TimesheetOvertimeConfig,  res);
      this.growlService.add(GrowlType.Success, "Generated Configuration Successfully");
      this.displayGenerateOvertimeDialog = false;
    });
  }

  private getDropDowns(): void {
    forkJoin([this.timesheetAdminDataService.getUsersOnAlternateSchedule(), this.calendarService.getCalendarYearsAsDropdown(CalendarType.Timesheet, true, false)])
    .subscribe(res => {
      this.users = plainToClass(UserSearch, res[0]);
      this.userDropDown = this.transformService.convertToDropDown('fullName', this.users, 'id');
      this.yearDropDown = res[1];
    });
  }

  private getOverTimeConfig() {
    if(this.selectedUser && this.selectedYear){
      this.timesheetAdminDataService.getOverTimeConfig(this.selectedUser, this.selectedYear).subscribe(res => {
        this.overtimeConfigs = plainToClass(TimesheetOvertimeConfig,  res);
      });
    }
  }


}
